/**
 * Asynchronously loads the component for HelpAndSupport
 */

import { lazyLoad } from "utils/loadable";

export const HelpAndSupport = lazyLoad(
  () => import("./index"),
  (module) => module.HelpAndSupport
);